import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'styled/Tooltip';
import HeaderTitle from 'styled/Page/HeaderTitle';

import { ReactComponent as Info } from 'icons/Info.svg';

import IconWrapper from './IconWrapper';

const METHODS_OF_TRANSACTION = {
  card: 'На карту',
  phone: 'На номер телефона',
  yandex_wallet: 'На яндекс-кошелек',
};

const METHODS_INFO = {
  card: 'Номер карты',
  phone: 'Номер телефона',
  yandex_wallet: 'Номер кошелька',
};

class TransactionTooltip extends React.PureComponent {
  state = {
    isMouseEnter: false,
  }

  handleMouseEnter = () => {
    this.setState({ isMouseEnter: true });
  }

  handleMouseLeave = () => {
    this.setState({ isMouseEnter: false });
  }

  render() {
    return (
      <div
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <IconWrapper isSmall={this.props.isSmall}>
          <Info />
        </IconWrapper>

        {this.state.isMouseEnter && (
          <Tooltip isSmall={this.props.isSmall}>
            <HeaderTitle>Тип перевода</HeaderTitle>

            <span>{METHODS_OF_TRANSACTION[this.props.method] || 'Не указан'}</span>

            <HeaderTitle style={{ marginTop: '24px' }}>{METHODS_INFO[this.props.method]}</HeaderTitle>

            <span>{this.props.methodInfo || 'Нет информации'}</span>
          </Tooltip>
        )}
      </div>
    );
  }
}

TransactionTooltip.propTypes = {
  method: PropTypes.oneOf(['card', 'phone', 'yandex_wallet']),
  methodInfo: PropTypes.string,
  isSmall: PropTypes.bool,
};

TransactionTooltip.defaultProps = {
  method: undefined,
  methodInfo: '',
  isSmall: false,
};

export default TransactionTooltip;
